<section id="natural-stone-color-list" class="py-3 px-4 md:py-6 md:px-8 relative">
    <div class="flex flex-col gap-2 mb-6">
        <div class="flex gap-5">
            <div>
                <span class="font-display font-medium text-2xl">
                    {{ 'natural_stone.natural_stone_catalog' | translate }}
                </span>
            </div>

            <div class="flex-1"></div>
            <div>
                <app-natural-stone-mini-cart></app-natural-stone-mini-cart>
            </div>
        </div>
        <app-natural-stone-color-filters></app-natural-stone-color-filters>
    </div>
    <div class="grid grid-cols-1 xs:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 lg:gap-6">
<!--        First card-->
        <div class="row-start-1 col-start-1 bg-background-medium-01 py-6 px-6 md:px-8 flex flex-col gap-4">
            <p class="m-0 typography-title-s text-xxl leading-7 font-light">
                {{'natural_stone.preorder_natural_stone_for_your_project' | translate | uppercase}}
            </p>
            <p class="flex-1 m-0 typography-title-s text-md leading-5 font-medium">
                {{'natural_stone.preorder_natural_stone_description' | translate}}
            </p>
            <app-link class="text-primary typography-body-m-regular" (onClick)="showTutorial()">
                <div class="flex items-center">
                    <span>
                        {{'benefits_we.know_more' | translate}}
                    </span>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9.99984 17.3L15.2998 12L9.99984 6.69995L9.29984 7.39995L13.8998 12L9.29984 16.6L9.99984 17.3Z" fill="currentColor"/>
                    </svg>
                </div>
            </app-link>
        </div>

<!--        Middle long card-->
        <div *ngIf="canSelectVirtualVisit" class="col-span-1 row-start-4 xs:col-span-2 xs:row-start-3 lg:col-span-3 xl:col-span-4 bg-background-medium-01 flex md:flex-wrap flex-col md:flex-row gap-4 items-center justify-center py-6 px-6 md:py-8">
            <span class="typography-title-m font-normal">
                {{'natural_stone.want_to_take_a_closer_look_at_the_slabs' | translate}}
            </span>
            <span class="typography-title-s text-xs font-normal me-4">
                {{'natural_stone.schedule_an_online_visit_with_one_of_our_specialists' | translate}}
            </span>
            <app-button [secondary]="true" [showIcon]="true" [transparent]="true" size="medium" (onClick)="openVirtualVisit()">
                {{'home.book_a_online_visit' | translate}}
            </app-button>
        </div>

        <app-natural-stone-color-card *ngFor="let color of colorList(); let index = index" [color]="color" [index]="index"></app-natural-stone-color-card>
    </div>
</section>

<app-confirm-modal
    [isOpen]="tutorialModalOpen"
    [hideFooter]="true"
    (onClose)="tutorialModalOpen = false"
    (onConfirm)="tutorialModalOpen = false"
>
    <app-natural-stone-tutorial-modal (closedEvent)="tutorialModalOpen = false"></app-natural-stone-tutorial-modal>
</app-confirm-modal>